/**
 * productLabel.ts — Etiqueta de producto COMPARTIDA por los motores de impresión
 * (IR webble, ticket Electron y PDF pdfMake).
 *
 * `productLabel` arma "{cantidad} x {nombre}" y solo agrega ` - {presentacion}` cuando la
 * presentación APORTA información: se omite si está vacía o si, normalizada (trim, espacios
 * colapsados, sin acentos, case-insensitive), es IGUAL al nombre.
 *
 * IGUALDAD ESTRICTA, NO CONTENCIÓN: el renderer no sabe cuántas presentaciones tiene el
 * producto (ProductOrder no trae opciones[]), que es justo la condición que separa un sufijo
 * redundante de uno discriminante. Un falso positivo haría que cocina pierda la variante sin
 * poder recuperarla del papel. Por eso "AGUA FRESCA 1 LITRO - 1 LITRO" se conserva a
 * propósito: es síntoma del catálogo, no del renderer.
 */

// Normaliza una etiqueta para COMPARAR (no para imprimir): NFD sin acentos, espacios
// colapsados, trim y lowercase.
export const normalizeLabel = (value: string | null | undefined): string =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

type ProductLabelInput = {
  cantidad: number;
  nombre: string;
  presentacion?: string | null;
};

// "{cantidad} x {nombre}" — con ` - {presentacion}` solo cuando la presentación aporta.
export const productLabel = (product: ProductLabelInput): string => {
  const presentation = (product.presentacion ?? '').trim();
  if (presentation === '' || normalizeLabel(presentation) === normalizeLabel(product.nombre)) {
    return `${product.cantidad} x ${product.nombre}`;
  }
  return `${product.cantidad} x ${product.nombre} - ${presentation}`;
};
